import * as React from 'react'
import {createRoot} from 'react-dom/client'
import {SWRConfig} from 'swr'
import {fromJust} from '@freckle/maybe'

import bugsnagClient from '@frontrow/console/src/helpers/exception-handlers/bugsnag-client'
import {initializeGlobalEventListeners} from '@frontrow/console/src/routers/init-global-event-listeners'
// Tailwind base/theme must come before app SCSS so app styles can override
import './globals.css'
import './main.scss'

import {setupAjax} from '@frontrow/console/src/helpers/api-helpers'
import AppRouter from './routers'
import {swrOptions} from '@frontrow/console/src/hooks/utils/swr-config'

const container = fromJust(document.getElementById('main-app'), 'Container not found')
setupAjax()
initializeGlobalEventListeners()

// @ts-ignore: Bugsnag React plugin is not typed
const ErrorBoundary = bugsnagClient.getPlugin('react').createErrorBoundary(React)

const app = (
  <ErrorBoundary>
    <SWRConfig value={swrOptions}>
      <AppRouter />
    </SWRConfig>
  </ErrorBoundary>
)
createRoot(container).render(app)
